import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import MultiSelectDropdown from 'components/ReusableComponents/MultiSelectDropdown'
import Toggle from 'components/ReusableComponents/Toggle/index'
import { hotelStatusNamesFilterable } from 'main/hotelStatuses'
import { parentChainNames } from 'main/hotelBrandsAndChains'

import styles from './DailyConversations.module.scss'

const FilterPanel = ({
  isOpen,
  onToggle,
  filterState,
  dispatchFilter,
  allHotelGroups,
  allHotelChains,
  botContextOptions
}) => {
  const {
    hotelNameSearch,
    selectedBotContexts,
    showUnreviewedOnly,
    botIntentFilter,
    sortBy,
    hotelGroups,
    chains,
    brands,
    subsidiaryStatus,
    justShowFlagged
  } = filterState

  return (
    <div className={styles.filterPanel}>
      <div className={styles.filterPanelHeader} onClick={onToggle}>
        <span className={styles.filterPanelTitle}>Filters</span>
        <span className={styles.filterPanelToggle}>{isOpen ? '−' : '+'}</span>
      </div>
      {isOpen && (
        <div className={styles.filterPanelContent}>
          <div className={styles.filters}>
            <TextInput
              type="search"
              className={styles.searchInput}
              value={hotelNameSearch}
              onChangeValue={value =>
                dispatchFilter({ type: 'hotelNameSearch', payload: value })
              }
              placeholder="Search hotels & messages"
            />
            <Dropdown
              className={styles.dropdown}
              value={hotelGroups}
              onChange={e =>
                dispatchFilter({ type: 'hotelGroups', payload: e.target.value })
              }
              options={{
                all: 'All hotel groups',
                ...allHotelGroups
              }}
            />
            <Dropdown
              className={styles.dropdown}
              value={brands}
              onChange={e =>
                dispatchFilter({ type: 'brands', payload: e.target.value })
              }
              options={{
                all: 'All brands',
                ...parentChainNames
              }}
            />
            <Dropdown
              className={styles.dropdown}
              value={chains}
              onChange={e =>
                dispatchFilter({ type: 'chains', payload: e.target.value })
              }
              options={{
                all: 'All chains',
                ...allHotelChains
              }}
            />
            <MultiSelectDropdown
              className={styles.statusDropdown}
              options={hotelStatusNamesFilterable}
              value={subsidiaryStatus}
              hasUnselectButton
              onChangeValue={value =>
                dispatchFilter({ type: 'subsidiaryStatus', payload: value })
              }
              itemName="statuses"
            />
            <MultiSelectDropdown
              className={styles.statusDropdown}
              options={botContextOptions}
              value={selectedBotContexts}
              hasUnselectButton
              onChangeValue={value =>
                dispatchFilter({ type: 'selectedBotContexts', payload: value })
              }
              itemName="bot context"
              itemNamePlural="bot contexts"
            />
            <Dropdown
              className={styles.dropdown}
              options={{
                all: 'All conversations',
                hasIntent: 'Has bot intent',
                noIntent: 'No bot intent'
              }}
              value={botIntentFilter}
              onChange={e =>
                dispatchFilter({ type: 'botIntentFilter', payload: e.target.value })
              }
              defaultVal="All conversations"
            />
            <Dropdown
              className={styles.dropdown}
              options={{
                hotelNameAsc: 'Hotel Name (A-Z)',
                hotelNameDesc: 'Hotel Name (Z-A)',
                messageCountDesc: 'Most Messages',
                messageCountAsc: 'Least Messages',
                unreviewedFirst: 'Unreviewed First',
                flaggedFirst: 'Flagged First'
              }}
              value={sortBy}
              onChange={e =>
                dispatchFilter({ type: 'sortBy', payload: e.target.value })
              }
              defaultVal="Sort by"
            />
          </div>
          <div className={styles.toggleContainer}>
            <Toggle
              label="Unreviewed only"
              checked={showUnreviewedOnly}
              handleChange={e =>
                dispatchFilter({
                  type: 'showUnreviewedOnly',
                  payload: e.target.checked
                })
              }
              className={styles.lowResultToggle}
            />
            <Toggle
              label="Just flagged"
              checked={justShowFlagged}
              handleChange={e =>
                dispatchFilter({
                  type: 'justShowFlagged',
                  payload: e.target.checked
                })
              }
              className={styles.lowResultToggle}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterPanel

